module.exports = __webpack_public_path__ + "img/defaultPic1.665ea264.png";